<template>
  <div
    class="share-mask-layer"
    v-show="MASK_ACTIVE"
    @click.self="closeMask"
    @mousewheel.stop.prevent
  >
    <div class="share-container">
      <div class="share_link">
        <div class="share_link_close">
          <p>シェア</p>
          <img src="@/assets/images/home/clack_no.png" @click="closeMask" />
        </div>
        <div class="share_link_logo">
          <div
            class="share_link_tw share_link_logos"
            @click="shareSns('tw', ID)"
          >
            <img src="@/assets/images/login/twitter_icon.png" />
            <p>Twitter</p>
          </div>
          <!-- <div
            class="share_link_fb share_link_logos"
            @click="shareSns('fb', ID)"
          >
            <img src="@/assets/images/home/fw.png" />
            <p>Facebook</p>
          </div> -->
        </div>
        <div class="share_link_copy">
          <p>{{ worksUrl }}</p>
          <button
            class="copy"
            ref="copyButton"
            :data-clipboard-text="worksUrl"
          >
            COPY
          </button>
        </div>
      </div>
      <div class="annotation"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Clipboard from "clipboard";

export default {
  name: "ShareMask",

  components: {},
  data: () => ({}),
  created() {},

  mounted() {
    this.initClipboard();
  },
  watch: {},
  computed: {
    ...mapState({
      MASK_ACTIVE: (state) => state.ShareMask.MASK_ACTIVE,
      VIDEOID: (state) => state.ShareMask.VIDEOID,
      ID: (state) => state.ShareMask.ID,
    }),
    worksUrl() {
      return `${window.location.origin}/dormdesign/watch?worksid=${this.ID}`;
    },
  },
  methods: {
    closeMask() {
      this.$store.commit("ShareMask/SET_MASK_ACTIVE", false);
    },
    shareSns(channel, id) {
      this.$utils.snsShare(channel, id);
    },
    // 初始化复制插件
    initClipboard() {
      const clipboard = new Clipboard(this.$refs.copyButton);
      clipboard.on("success", (e) => {
        // console.log('复制成功')
      });
      clipboard.on("error", (e) => {
        // console.log('复制失败，请再次尝试')
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.share-mask-layer {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;

  .share-container {
    .share_link {
      box-sizing: border-box;
      padding: pxTorem(18px) pxTorem(15px) pxTorem(60px);
      position: absolute;
      width: pxTorem(600px);
      height: pxTorem(300px);
      top: 10%;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      background: #000 url("../assets/images/vote_mask/vote_bg.png") no-repeat;
      .share_link_close {
        display: flex;
        justify-content: space-between;
        p {
          font-size: pxTorem(16px);
          color: black;
          font-weight: 900;
        }
        img {
          cursor: pointer;
          width: pxTorem(16px);
          height: pxTorem(16px);
        }
      }
      .share_link_logo {
        text-align: center;
        box-sizing: border-box;
        padding: 0 pxTorem(160px);
        display: flex;
        margin-top: pxTorem(50px);
        justify-content: center;
        .share_link_logos {
          cursor: pointer;
          img {
            width: pxTorem(62px);
            height: pxTorem(62px);
          }
          p {
            color: black;
            font-size: pxTorem(18px);
            font-weight: 700;
            margin-top: pxTorem(9px);
          }
        }
      }
      .share_link_copy {
        margin-top: pxTorem(30px);
        color: #666565;
        font-size: pxTorem(18px);
        margin-left: pxTorem(28px);
        box-sizing: border-box;
        padding: 0 pxTorem(10px);
        display: flex;
        justify-content: space-between;
        border: 1px solid #6c6c6c;
        height: pxTorem(40px);
        width: pxTorem(516px);
        overflow: hidden;
        line-height: pxTorem(40px);
        p {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .copy {
          color: #0078f0;
          font-weight: 600;
          cursor: pointer;
          background: transparent;
        }
      }
    }
    .annotation {
      font-size: pxTorem(18px);
      width: pxTorem(1000px);
      position: absolute;
      top: 76%;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>